(function () {
    const HIJACK_PATTERNS = [
        'trafficshost.com',
        'gotrackier.com',
        'adtrack.',
    ];

    function isHijackUrl(url) {
        if (!url) return false;
        return HIJACK_PATTERNS.some(pattern => url.includes(pattern));
    }

    function report(type, url) {
        // 解析堆栈，找到第一个非本脚本的调用行
        const stack = new Error().stack || '';
        const lines = stack.split('\n');

        // 跳过前几行（Error本身 + report函数 + 拦截函数），找到真正的调用者
        const callerLines = lines.slice(3).filter(line =>
            line.trim() &&
            !line.includes('hijack') &&
            !line.includes('<anonymous>')
        );

        const caller = callerLines[0] ? callerLines[0].trim() : '未能定位';

        console.group('🚨 [联盟劫持检测] ' + type);
        console.warn('劫持 URL:', url);
        console.warn('触发位置:', caller);
        console.warn('完整堆栈:');
        // 打印每一行堆栈，方便点击跳转
        lines.slice(1).forEach((line, i) => {
            if (line.trim()) console.warn(`  ${i}: ${line.trim()}`);
        });
        console.groupEnd();
    }

    // =============================
    // 1. 监听 <a> 链接点击
    // =============================
    document.addEventListener('click', function (e) {
        const a = e.target.closest('a');
        if (a && isHijackUrl(a.href)) {
            e.preventDefault();
            e.stopImmediatePropagation();
            report('<a> 链接点击', a.href);
        }
    }, true);

    // =============================
    // 2. 监听 location.assign
    // =============================
    const origAssign = window.location.assign.bind(window.location);
    window.location.assign = function (url) {
        if (isHijackUrl(url)) {
            report('location.assign()', url);
            return;
        }
        return origAssign(url);
    };

    // =============================
    // 3. 监听 location.replace
    // =============================
    const origReplace = window.location.replace.bind(window.location);
    window.location.replace = function (url) {
        if (isHijackUrl(url)) {
            report('location.replace()', url);
            return;
        }
        return origReplace(url);
    };

    // =============================
    // 4. 监听 window.open
    // =============================
    const origOpen = window.open;
    window.open = function (url) {
        if (isHijackUrl(url)) {
            report('window.open()', url);
            return null;
        }
        return origOpen.apply(this, arguments);
    };

    // =============================
    // 5. 监听 history.pushState / replaceState
    // =============================
    const origPushState = history.pushState;
    const origReplaceState = history.replaceState;

    history.pushState = function (state, title, url) {
        if (isHijackUrl(url)) {
            report('history.pushState()', url);
            return;
        }
        return origPushState.apply(this, arguments);
    };

    history.replaceState = function (state, title, url) {
        if (isHijackUrl(url)) {
            report('history.replaceState()', url);
            return;
        }
        return origReplaceState.apply(this, arguments);
    };

    // =============================
    // 6. 监听动态注入脚本
    // =============================
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.tagName === 'SCRIPT' && node.src && isHijackUrl(node.src)) {
                    report('动态 <script> 注入', node.src);
                    node.remove();
                }
                if (node.tagName === 'IFRAME' && node.src && isHijackUrl(node.src)) {
                    report('动态 <iframe> 注入', node.src);
                    node.remove();
                }
            });
        });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    // =============================
    // 7. 监听 fetch
    // =============================
    const origFetch = window.fetch;
    window.fetch = function (input) {
        const url = typeof input === 'string' ? input : (input && input.url);
        if (isHijackUrl(url)) {
            report('fetch()', url);
            return Promise.reject(new Error('blocked by hijack detector'));
        }
        return origFetch.apply(this, arguments);
    };

    // =============================
    // 8. 监听 XMLHttpRequest
    // =============================
    const origXHROpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
        if (isHijackUrl(url)) {
            report('XMLHttpRequest.open()', url);
            return origXHROpen.call(this, method, 'about:blank');
        }
        return origXHROpen.apply(this, arguments);
    };

    // =============================
    // 9. 监听 location.href 赋值
    // =============================
    try {
        const origHrefDescriptor = Object.getOwnPropertyDescriptor(window.location, 'href')
            || Object.getOwnPropertyDescriptor(Location.prototype, 'href');

        if (origHrefDescriptor && origHrefDescriptor.set) {
            Object.defineProperty(window.location, 'href', {
                set: function (url) {
                    if (isHijackUrl(url)) {
                        report('location.href =', url);
                        return;
                    }
                    origHrefDescriptor.set.call(window.location, url);
                },
                get: function () {
                    return origHrefDescriptor.get.call(window.location);
                },
                configurable: true
            });
        }
    } catch (e) {
        console.log('[劫持检测] location.href 拦截不支持:', e.message);
    }

    console.log('[联盟劫持检测] 已启动，监控域名:', HIJACK_PATTERNS);
})();